import { Quote } from "../api/Quote/Quote";
import { EQuoteType, EQuotePurchaserType } from "../api/Types";

type Environment = "dev" | "staging" | "production";

const getEnvironment = (): Environment => {
  const hostname = window.location.hostname;
  if (hostname.includes("dev")) return "dev";
  if (hostname.includes("staging")) return "staging";
  return "production";
};

const REDIRECT_URLS = {
  dev: {
    internal: "https://hub.dev.swyftenergy.ie",
    public: "https://bge.dev.swyftenergy.ie"
  },
  staging: {
    internal: "https://hub.staging.swyftenergy.ie",
    public: "https://bge.staging.swyftenergy.ie"
  },
  production: {
    internal: "https://hub.swyftenergy.ie",
    public: "https://quote.energyupgrade.bordgais.ie"
  }
};

export const shouldRedirectQuote = (quote: Quote): boolean => {
  return quote.type !== EQuoteType.Boiler && quote.purchaserType !== EQuotePurchaserType.Farm;
};

export const getCustomerQuoteRedirectUrl = (quoteId: string): string => {
  const env = getEnvironment();
  return `${REDIRECT_URLS[env].public}/quote/${quoteId}`;
};

export const getInternalQuoteRedirectUrl = (quoteId: string): string => {
  const env = getEnvironment();
  return `${REDIRECT_URLS[env].internal}/store/quote/${quoteId}`;
};
